import Text from 'components/Text/Text';
import React, { useCallback, useState } from 'react';
import { NEW_EMAIL_PREFIX, NEW_COPY_EMAIL_PREFIX } from '../../../../../reportsContainerState/reportsContainerContext';
import { IEmails } from '../../../reportsContext/reportsState/reportsContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './AddEmailBtn.module.scss';

interface IAddEmailBtn {
	addEmails?: (value: IEmails) => void;
	addCopyEmails?: (value: IEmails) => void;
}

const AddEmailBtn: React.FC<IAddEmailBtn> = ({ addEmails, addCopyEmails }) => {
	const [emailIdCounter, setEmailIdCounter] = useState(1);

	const handleClick = useCallback(() => {
		setEmailIdCounter((prevState) => prevState + 1);

		if (addEmails) {
			const id = `${NEW_EMAIL_PREFIX}/${emailIdCounter}`;
			addEmails({
				id,
				email: '',
			});
		} else if (addCopyEmails) {
			const id = `${NEW_COPY_EMAIL_PREFIX}/${emailIdCounter}`;
			addCopyEmails({
				id,
				email: '',
			});
		}
	}, [addEmails, addCopyEmails, emailIdCounter]);

	return (
		<Button
			className={style.addBtn}
			theme="primary"
			onClick={handleClick}
			data-test="AddEmailBtn"
			iconPosition="post"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}>
			<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(AddEmailBtn);
